import AppConstants from '../constants/AppConstants';

export const initialState = {};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.USER_INFO_LOAD_SUCCESS:
            return { ...state, ...action.items };

        default:
            return state;
    }
};
